import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GetUsersResponse, User} from '../interfaces/users.interface'
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})

export class UserService {

  private apiUrl = `${environment.apiUrl}/User`;

  constructor(private http: HttpClient) {
  }

  getAllUsers(): Observable<GetUsersResponse> {
    return this.http.get<GetUsersResponse>(`${this.apiUrl}/GetAllUsers`);
  }

  getUser(user: any): Observable<User> {
    let params = new HttpParams();
    params = params.append('Name', user.userName);
    params = params.append('Password', user.userPassword);
    return this.http.get<User>(`${this.apiUrl}/LoginUser`, {params: params});
  }

  getUserAD(user: any): Observable<User> {
    let params = new HttpParams();
    params = params.append('Name', user.userName);
    return this.http.get<User>(`${this.apiUrl}/LoginUserAD`, {params: params});
  }

  addUser(user: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/AddUser`, user);
  }

  addUserAD(user: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/AddUserAD`, user);
  }

  deleteUser(user: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/DeleteUser`, user);
  }

  updateUser(user: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/UpdateRole`, user);
  }
}
